// GraphQL hook to check diagnostic dumps availability for a given time range
import { gql, useLazyQuery } from '@apollo/client';
import {AnyObject} from "../../models/types";

export interface CheckDiagnosticDumpsExistVars {
  domainId: string;
  startTime: string;
  endTime?: string;
  hours?: string;
}

interface CheckDiagnosticDumpsExistResponse {
  checkDiagnosticDumpsExist: boolean;
}

const CHECK_DIAGNOSTIC_DUMPS_EXIST = gql`
    query CheckDiagnosticDumpsExist(
      $domainId: String!
      $startTime: String!
      $endTime: String
      $hours: String
    ) {
        checkDiagnosticDumpsExist(
          domainId: $domainId
          startTime: $startTime
          endTime: $endTime
          hours: $hours
        )
    }
`;

export const useCheckDiagnosticDumpsExist = () => {
  return useLazyQuery<AnyObject, CheckDiagnosticDumpsExistVars>(CHECK_DIAGNOSTIC_DUMPS_EXIST, {
    errorPolicy: 'all',
    fetchPolicy: 'no-cache'
  });
};
